import { BehaviorSubject } from 'rxjs'
import { first } from 'rxjs/operators'

const addSvgToMap = async ({ id, svgData, map }) => {
  const image = new Image(50, 55)
  const imageLoaded = new BehaviorSubject(false);
  image.addEventListener('load', () => { imageLoaded.next(true) }, { once: true })
  // console.log({ svgData })
  image.src = svgData
  await imageLoaded.pipe(first()).toPromise()

  map.addImage(id, image)
}

export default addSvgToMap



// WEBPACK FOOTER //
// ./src/utility/addSvgToMap.js